import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {},
	actions: {
		[ACTIONS.EVOLUTION.EVOLUTION_POST](
			{ commit, dispatch, state },
			filter = {},
		) {
			return API.EVOLUTION.POST(filter).then(res => {
				return res
			})
		},
		[ACTIONS.EVOLUTION.FOLLOWERS](
			{ commit, dispatch, state },
			{ accounts, gte, lte },
		) {
			return API.EVOLUTION.FOLLOWERS({ accounts, gte, lte }).then(res => {
				return res
			})
		},
	},
}
